<template>
  <div class="select-option" :style="{ width: width ? width : '200px' }">
    <b-form-select
      v-model="selected"
      :options="options"
      :style="{ 'min-height': height || 'auto' }"
    ></b-form-select>
    <p v-if="textHelper" class="helper">{{ textHelper }}</p>
  </div>
</template>
<script>
export default {
  name: "SelectOption",
  props: {
    value: {},
    options: Array, // the options { value:'', label: '',}
    width: String,
    height: String,
    handleChangeOption: Function,
    textHelper: String,
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        if (this.handleChangeOption) this.handleChangeOption(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.select-option {
  select {
    height: 34px !important;
    padding: 0 12px !important;
    outline-color: #e6e6e6 !important;
    border-color: #e6e6e6 !important;
    width: 100%;
    appearance: none;
    background-image: url(../../assets/svg/arrow-down.svg);
    background-repeat: no-repeat;
    background-position: right 1.2rem top 50%;
    background-size: 1.6rem auto;
    font-size: 1.8rem;
  }

  .helper {
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 100%;
    letter-spacing: -0.05em;
    color: #626262;
    padding-top: 12px;
  }
}
</style>
